/* eslint-disable */
import { ChangeEvent, ReactElement, useEffect, useState } from "react";
import {
  App,
  Button,
  Col,
  Input,
  Popconfirm,
  Row,
  Space,
  Spin,
  Tooltip,
} from "antd";
import { CloseOutlined, DeleteOutlined, EditOutlined, MessageOutlined } from "@ant-design/icons";
import * as React from "react";
import { useStore } from "../../../stores/root-store-context";
import { observer } from "mobx-react-lite";
import dayjs from "dayjs";
import { formatPhoneForDisplay, isValidPhoneNumber } from "../../../../../../../../utils/phoneDisplayFormat";
import EditNameAddressForm from "./AccountInfo/EditNameAddressForm";
import Badge from "Components/Badge/Badge";
import { clone } from "lodash";
import ResponsiveGrid from "Components/TableMui/ResponsiveGrid";
import AddContactInfoModal from "./AddContactInfoModal";
import { TypeAddModal } from "../../../stores/RicStore";
import EStatementModal from "./eStatementModal";
import { formatContactFullName } from "../../../../../../../../utils/nameDisplayFormat";
import { DISPLAY_DATE_FORMAT } from "../helpers/dateValidation";


const styles = {
  phoneContainer: {
    display: "block",
    width: "100%",
    marginBottom: 10,
    marginRight: 10,
    height: 40,
    lineHeight: 40,
  },
  phoneList: {
    display: "flex",
    flexDirection: "column" as const,
    width: "100%",
    padding: "6px 0",
  },
  phoneLine: {
    whiteSpace: "nowrap" as const,
    lineHeight: 1.5,
  },
  smsBadgeIcon: {
    marginRight: 4,
    fontSize: 11,
  },
};
export type PhoneData = {
  methodId: number;
  phoneType: string;
  type: number;
  number: string | null;
};
export type ContactInformation = {
  accountNumber: string;
  activeFutures: null | any;
  activeRenters: null | any;
  address: string;
  address2: string;
  allowContactBySms: boolean;
  birthdate: null | any;
  businessPhone: null | any;
  businessPhoneMethodId: null | any;
  contactAddress?: {
    referenceID: string;
    mailingName: string;
    mailingName2: string;
    mailingSalutation: string;
    mailingAddress1: string;
    mailingAddress2: string;
    mailingCity: string;
    mailingRegion: string;
    mailingCountry: string;
    mailingPostalCode: string;
    unitKey: string;
  } | null;
  contactFullName: string;
  contactId: string;
  dateReceived: null | any;
  email: string | null;
  emailMethodId: number | null;
  employeeKey: null | any;
  expirationDate: null | any;
  firstName: string;
  futures: null | any;
  homePhone: null | any;
  homePhoneMethodId: null | any;
  id: string;
  isETrakType: boolean;
  isMain: boolean;
  lastName: string;
  mainAcc: null | any;
  mobilePhone: null | any;
  mobilePhoneMethodId: null | any;
  modifiedString: null | any;
  noActiveFutures: null | any;
  noActiveRenters: null | any;
  note: null | any;
  occupancy: boolean;
  owner: boolean;
  phones: PhoneData[];
  primaryOwner: string;
  rc_Date5: string;
  renters: null | any;
  salutation: string;
  type: string;
  user: null | any;
  writeAccess: boolean;
  isDeleted: boolean | null;
};
export const PhoneInputNumber = observer(
  ({
    phoneData,
    onChange,
    onBlur,
    onRemove,
    disabled,
    isNonPopconfirm,
    ricStyle,
  }: {
    phoneData: PhoneData;
    onChange?: (phoneData: PhoneData) => void;
    onBlur?: (event: React.FocusEvent<HTMLInputElement, Element>) => void;
    onRemove?: (phoneData: PhoneData) => void;
    disabled: boolean;
    isNonPopconfirm?: boolean;
    ricStyle?: boolean;
  }) => {
    const [phone, setPhone] = useState<string>(
      phoneData.number
        ? phoneData.number.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3")
        : ""
    );
    const mask = "___-___-____";

    const onChangeInternal = async (event: ChangeEvent<HTMLInputElement>) => {
      if (!disabled && onChange !== undefined) {
        const inputValue = event.target.value;
        const digitsOnly = inputValue.replace(/\D/g, "").slice(0, 10);
        let numIndex = 0;
        const newMask = mask.replace(
          /_/g,
          (_) => digitsOnly[numIndex++] || "_"
        );
        await setPhone(newMask);
        let lastDigitIndex = newMask.search(/\d(?!.*\d)/);
        lastDigitIndex = lastDigitIndex === -1 ? 0 : lastDigitIndex + 1;
        (event.nativeEvent.target as HTMLInputElement).setSelectionRange(
          lastDigitIndex,
          lastDigitIndex
        );
        phoneData.number = digitsOnly;
        onChange(phoneData);
      }
    };

    const handleInputClick = async (
      event: React.MouseEvent<HTMLInputElement, MouseEvent>
    ) => {
      if (!phone || phone === mask) {
        await setPhone("___-___-____");
        (event.target as HTMLInputElement).value = mask;
        (event.target as HTMLInputElement).setSelectionRange(0, 0);
      }
    };

    const removeButton = (
      <Button
        disabled={disabled}
        className={ricStyle ? "ric-phone-group__remove" : undefined}
        style={{ background: "none", border: "none", color: "#5a7890" }}
        onClick={isNonPopconfirm ? () => onRemove && onRemove(phoneData) : undefined}
        icon={<CloseOutlined disabled={disabled} />}
      />
    );
    const removeControl = !isNonPopconfirm ? (
      <Popconfirm
        title="DELETE CONTACT INFORMATION?"
        rootClassName={ricStyle ? "ric-modal" : undefined}
        description={
          <div className="ric-confirm-text">
            Please confirm you'd like to delete this contact information.
          </div>
        }
        okText="Delete"
        cancelText="Cancel"
        onConfirm={() => {
          onRemove && onRemove(phoneData);
        }}
      >
        {removeButton}
      </Popconfirm>
    ) : (
      removeButton
    );

    const isPhoneValid = isValidPhoneNumber(phone);
    const phoneErrorMessage = !isPhoneValid ? (
      <div style={{ color: "#ff4d4f", fontSize: 12, marginTop: 2 }}>
        Phone number must have 10 digits (___-___-____).
      </div>
    ) : null;

    if (ricStyle) {
      return (
        <div>
          <div className="ric-phone-group">
            {removeControl}
            <Input
              id="phone"
              className="ric-phone-group__input"
              disabled={disabled}
              status={!isPhoneValid ? "error" : ""}
              value={phone}
              onChange={onChangeInternal}
              onBlur={onBlur}
              onClick={handleInputClick}
              placeholder={phoneData.phoneType}
            />
            <span className="ric-phone-group__type">{phoneData.phoneType}</span>
          </div>
          {phoneErrorMessage}
        </div>
      );
    }

    return (
      <div style={{ width: "100%" }}>
        <Input
          id="phone"
          style={styles.phoneContainer}
          disabled={disabled}
          status={!isPhoneValid ? "error" : ""}
          addonBefore={removeControl}
          value={phone}
          onChange={onChangeInternal}
          onBlur={onBlur}
          onClick={handleInputClick}
          addonAfter={phoneData.phoneType}
          placeholder={phoneData.phoneType}
        />
        {phoneErrorMessage}
      </div>
    );
  }
);

export enum ContactType {
  EMAIL = 1,
  WORK = 2,
  HOME = 3,
  MOBILE = 4,
  NOTE = 5,
  PLUSPHONE = 6,
  BIRTHDATE = 11,
  EXPIRATIONDATE = 12,
  DATERECEIVED = 13,
}

export enum TypeForUpdateNote {
  MODIFIED = 1,
  DELETED = 2,
  CREATED = 3,
}

const PIN_MIN_WIDTH = 1400;

const useCanPinColumns = (): boolean => {
  const [canPin, setCanPin] = useState<boolean>(
    typeof window !== "undefined" ? window.innerWidth >= PIN_MIN_WIDTH : true
  );

  React.useEffect(() => {
    const update = () => setCanPin(window.innerWidth >= PIN_MIN_WIDTH);
    update();
    window.addEventListener("resize", update);
    return () => window.removeEventListener("resize", update);
  }, []);

  return canPin;
};
const ContactInfo = observer(
  (props: {
    contactInfo: ContactInformation[];
    isDelete?: boolean;
  }): ReactElement => {
    const { contactInfo } = props;
    const { ricStore, applicationStore } = useStore();
    const [localContactInfo, setLocalContactInfo] =
      useState<ContactInformation>();
    const [isUpdating, setIsUpdating] = useState<boolean>(false);
    const [isOpenModal, setIsOpenModal] = useState<boolean>(false);
    const { message } = App.useApp();
    const canPin = useCanPinColumns();
    const pinLeft = canPin ? ("left" as const) : undefined;
    const [contactPage, setContactPage] = useState<number>(1);
    const [contactPageSize, setContactPageSize] = useState<number>(10);

    useEffect(() => {
      const maxPage = Math.max(1, Math.ceil(contactInfo.length / contactPageSize));
      if (contactPage > maxPage) {
        setContactPage(maxPage);
      }
    }, [contactInfo.length, contactPageSize, contactPage]);
    
    const [contactSortModel, setContactSortModel] = useState<
      { field: string; sort: "asc" | "desc" }[]
    >([]);

    const defaultCompare = (a: any, b: any): number => {
      if (a == null && b == null) return 0;
      if (a == null) return -1;
      if (b == null) return 1;
      if (typeof a === "number" && typeof b === "number") return a - b;
      return String(a).localeCompare(String(b), undefined, { numeric: true });
    };
    const sortedContactInfo = React.useMemo(() => {
      if (!contactSortModel.length) return contactInfo;
      const { field, sort } = contactSortModel[0];
      const dir = sort === "desc" ? -1 : 1;
      return [...contactInfo].sort(
        (a, b) => dir * defaultCompare(a?.[field], b?.[field])
      );
    }, [contactInfo, contactSortModel]);

    const error = (): void => {
      message.open({
        type: "error",
        content: "Error occurred during saving. Please check the entered data.",
      })();
    };

    const deleteAccount = (
      methodId: number,
      type: string,
      deletedValue: string
    ): void => {
      setIsUpdating(true);
      const str = `${type} ${deletedValue} deleted for contact id ${
        localContactInfo.contactId
      }, ${localContactInfo.contactFullName
        ?.replace("&", "")
        .replace("*", "")}`;
      ricStore
        .deleteAccountContactInfo(
          methodId.toString(),
          str,
          localContactInfo.accountNumber,
          applicationStore.userEmployee.employeeID
        )
        .then(() => {
          ricStore.getRicInfo().catch(console.log);
          setIsUpdating(false);
        })
        .catch((err) => {
          console.log(err);
          setIsUpdating(false);
          error();
        });
    };

  const updateAccount = (
      contactData: ContactInformation,
      modifiedString?: string
    ): void => {
      setIsUpdating(true);
      setLocalContactInfo({ ...contactData, modifiedString: null });
      ricStore
        .updateAccount(
          { ...contactData, modifiedString: modifiedString },
          applicationStore.userEmployee.employeeKey,
          applicationStore.userEmployee.employeeID
        )
        .then(() => {
          contactData.isDeleted = false;
          setIsUpdating(false);
     setLocalContactInfo({ ...contactData, isDeleted: false});
        })
        .catch((err) => {
          console.log(err);
  setLocalContactInfo({ ...contactData, isDeleted: false });
          setIsUpdating(false);
          error();
        });
    };
   
    const columns = [
      {
        field: "type",
        label: "Contact Type",
        width: 150,
        sortable: false,
        pinned: pinLeft,
        render: (value) => (value === "Owner" ? "All" : value),
      },
      {
        field: "contactId",
        label: "Contact ID",
        width: 130,
        pinned: pinLeft,
      },
      {
        field: "primaryOwner",
        label: "Owner Status",
        width: 140,
        pinned: pinLeft,
        render: (value) =>
          value === "Yes" ? (
            <Badge text="Owner" variant="green" />
          ) : (
            <Badge text="Non-Owner" variant="gray" />
          ),
      },
      {
        field: "contactFullName",
        label: "Contact Full Name",
        width: 200,
        primary: true,
        pinned: pinLeft,
        render: (_, record) => (
          <strong>{formatContactFullName(record?.firstName, record?.lastName)}</strong>
        ),
      },
      {
        field: "email",
        label: "Email",
        flex: 1.2,
        minWidth: 160,
      },
      {
        field: "phones",
        label: "Phones",
        flex: 1.6,
        minWidth: 200,
        sortable: false,
        render: (value, row) => (
          <div style={styles.phoneList}>
            {row?.phones?.filter((phone) => phone.number)?.map((phone, index) => (
              <div key={index} style={styles.phoneLine}>
                <strong>{phone?.phoneType}:</strong> {formatPhoneForDisplay(phone?.number)}
              </div>
            ))}
          </div>
        ),
      },
      {
        field: "allowContactBySms",
        label: "Text Messaging",
        width: 160,
        render: (value) =>
          value ? (
            <Badge
              text={
                <>
                  <MessageOutlined style={styles.smsBadgeIcon} />
                  Signed Up
                </>
              }
              variant="green"
            />
          ) : (
            <Badge text="Not Signed Up" variant="gray" />
          ),
      },
      {
        field: "birthdate",
        label: "D.O.B",
        flex: 1,
        minWidth: 110,
        render: (value, row) =>
          row.birthdate ? dayjs(row.birthdate)?.format(DISPLAY_DATE_FORMAT) : "-",
      },
      {
        field: "expirationDate",
        label: "HOPA Expiration Date",
        flex: 1.3,
        minWidth: 200,
        render: (value, row) =>
          row.expirationDate ? dayjs(row.expirationDate)?.format(DISPLAY_DATE_FORMAT) : "-",
      },
      {
        field: "dateReceived",
        label: "HOPA Date Received",
        flex: 1.3,
        minWidth: 200,
        render: (value, row) =>
          row?.dateReceived ? dayjs(row.dateReceived)?.format(DISPLAY_DATE_FORMAT) : "-",
      },
      {
        field: "note",
        label: "Note",
        flex: 0.7,
        minWidth: 90,
      },
      {
        field: "address",
        label: "Mailing Address",
        flex: 2.2,
        minWidth: 280,
        sortable: false,
        render: (value, row) => (
          <div>
            {row.address && <div><strong>Address 1:</strong> {row.address}</div>}
            {row.address2 && <div><strong>Address 2:</strong> {row.address2}</div>}
          </div>
        ),
      },
      {
        field: "actions",
        label: "Actions",
        width: 120,
        sortable: false,
        pinned: "right" as const,
        render: (value, row) => (
          <Space size="middle" style={{ display: "flex", alignItems: "center", justifyContent: "flex-start" }}>
            <Tooltip title="Edit">
              <button
                type="button"
                className="ric-icon-btn ric-icon-btn--edit"
                aria-label="Edit contact"
                data-testid={`ric-edit-contact-btn-${row?.contactId}`}
                onClick={() => {
                 handleEdit(row)
                }}
              >
                <EditOutlined className="icon-action-edit" />
              </button>
            </Tooltip>
            {row?.primaryOwner === "No" ? (
            <Popconfirm
              title="PERMANENTLY REMOVE CONTACT"
              rootClassName="ric-popconfirm"
              description={
                <div className="ric-confirm-text">
                  Are you sure you want to permanently remove this contact from
                  account? This is not reversible and the contact will lose
                  access to all AAM systems.
                </div>
              }
              okText="Delete"
              cancelText="Cancel"
              disabled={!ricStore.isEditable}
              onConfirm={async () => {
                setIsUpdating(true);
                ricStore
                  .deleteAccountContactItem(
                    row,
                    applicationStore.userEmployee.employeeKey,
                    (status: boolean) => {
                      setIsUpdating(status);
                    }
                  )
                  .catch((error) => {
                    setIsUpdating(false);
                    console.log(error);
                  });
              }}
            >
              <Tooltip title="Delete">
                <button
                  type="button"
                  className={`ric-icon-btn ric-icon-btn--delete${!ricStore.isEditable ? " disabled" : ""}`}
                  aria-label="Delete contact"
                  disabled={!ricStore.isEditable}
                  data-testid={`ric-delete-contact-btn-${row?.contactId}`}
                >
                  <DeleteOutlined
                    className={`icon-action-delete${!ricStore.isEditable ? " disabled" : ""}`}
                  />
                </button>
              </Tooltip>
            </Popconfirm>
          ) : null}
          </Space>
        ),
      },
    ];
    const handleEdit = (data)=>{
      setLocalContactInfo(data)
      setIsOpenModal(true);
    }

    return (
      <Spin spinning={isUpdating}>
        <div className="ric-table">
          <Row gutter={[12, 20]} justify={"end"}>
            <Col xs={{ flex: "100%" }} sm={{ flex: "none" }}>
              <EStatementModal />
            </Col>
            <Col xs={{ flex: "100%" }} sm={{ flex: "none" }}>
              <AddContactInfoModal
                text={"Add Contact"}
                type={TypeAddModal.AddContact}
              />
            </Col>
            <Col span={24}>
              <ResponsiveGrid
                key={canPin ? "pinned" : "unpinned"}
                columns={columns}
                rows={sortedContactInfo.slice(
                  (contactPage - 1) * contactPageSize,
                  (contactPage - 1) * contactPageSize + contactPageSize
                )}
                getRowId={(row) => row.id}
                emptyText="No data."
                server={{
                  page: contactPage,
                  pageSize: contactPageSize,
                  total: contactInfo.length,
                  sortModel: contactSortModel,
                  onChange: (p, ps) => {
                    setContactPage(p);
                    if (ps) setContactPageSize(ps);
                  },
                  onSortChange: (model) => {
                    setContactSortModel(model ?? []);
                    setContactPage(1);
                  },
                }}
              />
            </Col>
          </Row>

        </div>
          
            {isOpenModal &&  <EditNameAddressForm
          isOpenModal={isOpenModal}
          dismissModal={() => {
            setIsOpenModal(false);
          }}
          contact={localContactInfo}
           contactInfo={clone(localContactInfo)}
          updateAccount={updateAccount}
          deleteAccount={deleteAccount}
        /> }
  
      </Spin>
    );
  }
);
export default ContactInfo;
